/** Base Error Class */
export class MfsError extends Error {
    constructor(message /** Our current error messages will go here */, statusCode /* error categorization */, innerError /*in case we catch some error & throw mfs error e.g DriverError*/) {
        super(message);
        this.statusCode = statusCode;
        this.innerError = innerError;
    }
}
//# sourceMappingURL=mfsError.js.map